import React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { hideModal } from '../../../../actions/modal';
import { RESULTS } from '../../../../constants/routes';

import Modal from '../..';
import Buttons from '../../buttons';
import { Content, ModalBodyContainer } from '../../components';

export const Message = styled.span``;

export const ForcedTerminationModalBody = ({ onClose }) => {
    const history = useNavigate();
    const onConfirm = () => {
        onClose();
        setTimeout(history, 0, RESULTS, { replace: true });
    };

    return (
        <Modal title="Prova salvata" onClose={onConfirm} closeOnClickOutside={false}>
            <ModalBodyContainer>
                <Content>
                    <Message className="body-3">{'Abbiamo salvato la tua prova. Ora puoi controllare i risultati.'}</Message>
                </Content>
                <Buttons primaryButtonClick={onConfirm} primaryButtonText="Vai ai risultati" showTertiaryButton={false} />
            </ModalBodyContainer>
        </Modal>
    );
};

ForcedTerminationModalBody.propTypes = {
    onClose: PropTypes.func.isRequired,
};

const actionsCreator = {
    onClose: hideModal,
};

export default connect(null, actionsCreator)(ForcedTerminationModalBody);
